import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { ScrollProgress } from "./components/ScrollProgress";
import { FloatingButtons } from "./components/FloatingButtons";
import { MobileStickyCTA } from "./components/MobileStickyCTA";
import { VisitTracker } from "./components/VisitTracker";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import LegalPage from "./pages/LegalPage";
import { Gallery } from "./components/sections/Gallery";
import { Hero } from "./components/sections/Hero";
import { PresentationVideo } from "./components/sections/PresentationVideo";
import { SocialProof } from "./components/sections/SocialProof";
import { Reviews } from "./components/sections/Reviews";
import { Bio } from "./components/sections/Bio";
import { Manifesto } from "./components/sections/Manifesto";
import { Press } from "./components/sections/Press";
import { SeriesSection } from "./components/sections/SeriesSection";
import { SportSection } from "./components/sections/SportSection";
import { Services } from "./components/sections/Services";
import { WeddingPackages } from "./components/sections/WeddingPackages";
import { FeaturedWedding } from "./components/sections/FeaturedWedding";
import { SignatureOptions } from "./components/sections/SignatureOptions";
import { Venues } from "./components/sections/Venues";
import { WhyMe } from "./components/sections/WhyMe";
import { Universe } from "./components/sections/Universe";
import { SpotifySection } from "./components/sections/SpotifySection";
import { DjMatchSection } from "./components/sections/DjMatchSection";
import { CTA } from "./components/sections/CTA";
import { ContactForm } from "./components/sections/ContactForm";
import { Footer } from "./components/sections/Footer";

const Home = () => {
  return (
    <div className="App relative">
      <ScrollProgress />
      <VisitTracker />
      <Header />
      <main>
        <Hero />
        <PresentationVideo />
        <SocialProof />
        <Reviews />
        <Bio />
        <Manifesto />
        <SeriesSection />
        <Press />
        <SportSection />
        <Services />
        <WeddingPackages />
        <FeaturedWedding />
        <SignatureOptions />
        <Venues />
        <WhyMe />
        <Gallery />
        <Universe />
        <SpotifySection />
        <DjMatchSection />
        <CTA />
        <ContactForm />
      </main>
      <Footer />
      <FloatingButtons />
      <MobileStickyCTA />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/mentions-legales" element={<LegalPage kind="mentions" />} />
        <Route path="/confidentialite" element={<LegalPage kind="privacy" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
